import Model from './model.js'

export default class Setting extends Model {
	static _routeKey = 'user-setting'
	tailIgnore = ['key', 'color']

	_logIcon() {
		return 'IconFolderDraftCircle'
	}

	tail = {
		createdDescription: () => '' + this.name + ' was created',
		removedDescription: () => '' + this.name + ' was deleted',
		name: () => [this.key != 'pipeline_stage' ? 'Folder name' : 'Pipeline stage', this.name],
		downloaded_at: () => ['downloaded at', this.downloaded_at != null ? this.vue.$help.formatDateTime(this.downloaded_at) : null],
		file_count: () => [
			'File count',
			this.file_count != null ? this.file_count + ' ' + this.vue.$help.pluralize('file', this.file_count) : null,
		],
		logType: (type) => {
			return { created: 'uploaded', updated: 'renamed', removed: 'deleted' }[type]
		},
	}

	_constructor() {
		let title = {
			pipeline_stage: 'stage',
			lead_source: 'lead source',
			default_folder: 'folder',
			folder: 'folder',
		}[this.key]

		let label = {
			pipeline_stage: 'pipeline stage',
			lead_source: 'lead source',
			default_folder: 'folder',
			folder: 'folder',
		}[this.key]

		let countName = {
			stage: 'deal',
			folder: 'file',
			'lead source': 'lead',
		}[title]

		let defaultCreateUpdateNames = ['Create', 'Edit']

		if (title == 'stage') {
			defaultCreateUpdateNames[1] = 'Rename'
		}

		this._getVars = {
			title: title,
			defaultCreateUpdateNames: defaultCreateUpdateNames,
			countName: countName,
			label: label,
		}
	}

	title() {
		let thing = this._getVars.title,
			form = this._getVars.defaultCreateUpdateNames[this.id == null ? 0 : 1]

		return form + ' ' + thing
	}

	countName() {
		return this._getVars.countName
	}

	me() {
		return this._getVars.label
	}

	label() {
		return this.$vue.$help.capitalizeFirstLetter(this._getVars.label)
	}
}
